module.exports = __webpack_public_path__ + "static/media/HCMM364.e884442f.jpg";